import { render, staticRenderFns } from "./feeding-page.vue?vue&type=template&id=762012fa"
import script from "./feeding-page.vue?vue&type=script&lang=js"
export * from "./feeding-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports